class AdminInstructorInvitationsController {
  constructor(InvitationsModel, FlashService) {
    this.InvitationsModel = InvitationsModel;
    this.FlashService = FlashService;
    this.invitations = [];
    this.loading = true;
    this.submitting = false;
    this.invite = {
      type: "email",
    };

    InvitationsModel.getInstructorInvitations().then((response) => {
      this.invitations = response.invitations;
      this.loading = false;
    });
  }

  getStatus(invite) {
    if (invite.accepted) {
      return "Accepted";
    }
    if (invite.revoked_at) {
      return "Revoked";
    }
    if (invite.expires_at && new Date(invite.expires_at) < new Date()) {
      return "Expired";
    }
    return "Pending";
  }

  canResend(invite) {
    return !invite.accepted;
  }

  canRevoke(invite) {
    return !invite.accepted && !invite.revoked_at;
  }

  sendInvitation() {
    const data = {
      invite_type: this.invite.type,
    };
    if (this.invite.type === "email") {
      data.email = this.invite.email;
    }
    if (this.invite.type === "phone") {
      data.phone = this.invite.phone;
    }
    this.submitting = true;
    this.InvitationsModel.sendInstructorInvitation(data)
      .then((response) => {
        this.submitting = false;
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        delete this.invite.phone;
        delete this.invite.email;
        this.refreshInvitations();
      })
      .catch(() => {
        this.submitting = false;
      });
  }

  revokeInvitation(invite) {
    this.InvitationsModel.revokeInstructorInvitation(invite.id)
      .then((response) => {
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        this.refreshInvitations();
      })
      .catch(() => {});
  }

  resendInvitation(invite) {
    this.InvitationsModel.resendInstructorInvitation(invite.id)
      .then((response) => {
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        this.refreshInvitations();
      })
      .catch(() => {});
  }

  refreshInvitations() {
    this.InvitationsModel.getInstructorInvitations().then((response) => {
      this.invitations = response.invitations;
    });
  }
}

AdminInstructorInvitationsController.$inject = [
  "InvitationsModel",
  "FlashService",
];

export default AdminInstructorInvitationsController;
